import { observer } from 'mobx-react-lite';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { PickerSmartphone } from './pickers/PickerSmartphone';
import { PickerFamilyFriends } from './pickers/PickerFamilyFriends';
import { PickerGooglePhoto } from './pickers/PickerGooglePhoto';
import { ScrollView, View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { brand } from 'src/theme/colors';
import { CircularButton } from '../../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../../focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '../../icon/icon.helper';
import TextLato from '../../text/text-lato/TextLato';
import { useStore } from 'src/contexts/StoreContext';
import { style } from './DrawerPhotoPicker.style';
import { useCustomScrollbar } from 'src/hooks/use-custom-visible-scrollbar/useCustomVisibleScrollbar';
import { PickerComputer } from './pickers/PickerComputer';
import { useDrawerPhotoPickerLogic } from './DrawerPhotoPicker.logic';

export const DrawerPhotoPicker = observer(() => {
  const { i18n, photoDrawer } = useStore();
  const scrollViewRef = useCustomScrollbar();

  const { onPressBack, ...pickerComputerProps } = useDrawerPhotoPickerLogic();

  return photoDrawer.picker === SELECTED_MENU_ITEMS.Computer ? (
    <PickerComputer {...pickerComputerProps} />
  ) : (
    <>
      <View style={style.header}>
        <CircularButton
          onPress={onPressBack}
          size={CIRCULAR_BUTTON_SIZES.SMALL}
          type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
          iconName={ICON_NAMES.ArrowLeft1}
          focusGroup={FocusGroups.MODAL}
          testID={modalTestID(TestIDs.CONFIGURATION_STEPS, TestIDs.BACK)}
          focusId={modalTestID(TestIDs.CONFIGURATION_STEPS, TestIDs.BACK)}
          focusOrder={0}
          iconStyle={{ color: brand.main.water }}
        />
        <TextLato style={style.title}>{i18n.t('photo-drawer:waiting-upload')}</TextLato>
        <View style={{ width: 24 }} />
      </View>
      <ScrollView
        ref={scrollViewRef}
        style={{ flex: 1 }}
        showsVerticalScrollIndicator={true}
        persistentScrollbar={true}
      >
        {photoDrawer.picker === SELECTED_MENU_ITEMS.GooglePhoto && <PickerGooglePhoto />}
        {photoDrawer.picker === SELECTED_MENU_ITEMS.Smartphone && <PickerSmartphone />}
        {photoDrawer.picker === SELECTED_MENU_ITEMS.FamilyFriends && <PickerFamilyFriends />}
      </ScrollView>
    </>
  );
});

DrawerPhotoPicker.displayName = 'DrawerPhotoPicker';
